import type { OnboardingEmailTemplate } from '../OnboardingEmailModal.types';

export const FOLLOW_UP_DOCUMENTS_TEMPLATE: OnboardingEmailTemplate = {
  id: 'follow-up-documents',
  label: 'Follow-up Document Request',
  emailSubject: 'Additional documents needed for your valuation',
  introduction: `Hi {{CONTACT_FIRST_NAME}},

We are following up on a few additional documents needed to complete the {{COMPANY_NAME}} valuation:`,
  documents: [
    {
      label: 'Updated Cap Table',
      name: 'Updated Cap Table',
      description: 'Most recent fully diluted capitalization table',
    },
    {
      label: 'Updated Financial Statements',
      name: 'Updated Financial Statements',
      description: 'Latest financials since the prior request',
    },
    {
      label: 'Recent Option Grants',
      name: 'Recent Option Grants',
      description: 'Option grants issued since the prior request',
    },
    {
      label: 'Supporting Schedules',
      name: 'Supporting Schedules',
      description: 'Schedules or exhibits needed to complete the valuation',
    },
  ],
};
